export const CREATING_PAYMENT = "CREATING_PAYMENT";
export const UPDATING_PAYMENT = "UPDATING_PAYMENT";
export const PAYMENT_CREATED = "PAYMENT_CREATED";
export const PAYMENT_UPDATED = "PAYMENT_UPDATED";
export const ERROR_PAYMENT_CREATE = "ERROR_PAYMENT_CREATE";
export const ERROR_PAYMENT_UPDATE = "ERROR_PAYMENT_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
